import T from '../services/language';
import React, {useEffect, useState} from "react";
import Loading from "../components/Loading";
import {useLocation, useNavigate} from "react-router-dom";
import {getCampaignByUrl, getClientConfig, getProductAndService} from "../services/app";

const App: any = React.createContext({});
//@ts-ignore
const win: any = window;

// CRA injects PUBLIC_URL at build time. Used so that static assets
// (/logo.svg, /icons/...) resolve correctly when the SPA is hosted
// under a sub-path (e.g. CloudFront /customer/).
const PUB = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
const assetUrl = (p: string) => win.location.origin + PUB + (p.startsWith('/') ? p : '/' + p);

export const AppProvider = ({children}) => {
    const [ready, setReady] = useState(false);
    const [loading, setLoading] = useState(false);
    const [campaign, setCampaign] = useState();
    const [campaignError, setCampaignError] = useState(false);
    const [customer, setCustomer] = useState<any>();
    const navigate = useNavigate();
    const location: any = useLocation();
    // `location` (from useLocation) is router-relative — basename already
    // stripped — so segments[0] is always the clientCode and segments[1]
    // the campaign share key, regardless of where the app is mounted
    // (root vs /customer subpath in stg).
    const _segs = (location?.pathname || "").split("/").filter(Boolean);
    const clientCode = _segs[0] && _segs[0] !== "404" ? _segs[0] : "";
    const campaignPath = _segs[1] && _segs[1] !== "404" ? _segs[1] : "";
    const [themeColors, setThemeColors] = useState({main: ""});
    const [business, setBusiness] = useState({});

    useEffect(() => {
        if (!!campaign) {
            const currentUrl = location.pathname + location.search;
            localStorage.setItem('pwaStartUrl', currentUrl);
        }
    }, [location, campaign, campaignError]);

    useEffect(() => {
        const run = async () => {
            let customerData;
            // set customer local
            if (localStorage.getItem('CUSTOMER')) {
                customerData = JSON.parse(localStorage.getItem('CUSTOMER'));
                setCustomer(customerData);
            }
            // get current camp
            if (campaignPath && !campaign) {
                let campaignLocal;
                // if (localStorage.getItem(`CAMPAIGN_${campaignPath}`)) {
                //     campaignLocal = JSON.parse(localStorage.getItem(`CAMPAIGN_${campaignPath}`))
                //     setCampaign(campaignLocal)
                // } else {
                const result = await getCampaignByUrl(campaignPath);
                if (result.status === 200) {
                    setCampaignError(false);
                    campaignLocal = result?.data?.data;
                    setCampaign(campaignLocal);
                } else {
                    const ignoreCampaignPaths = ['call','chat'];
                    if (!(
                        ignoreCampaignPaths.includes(campaignPath) && window.location.href.includes('/join')
                        || window.location.href.includes('/direct-chat/join')
                    )) {
                        console.log("Campaign not found, redirect to 404", campaignPath,
                            ignoreCampaignPaths.includes(campaignPath) && window.location.href.includes('/join')
                            , window.location.href,window.location.href.includes('/chat/join'));
                        setCampaignError(true);
                        navigate(`/${clientCode}/404/${campaignPath}`)
                    } else {
                        // set default theme for call and chat
                        setThemeColors({main: "#1D896D"});
                        setBusiness({});
                        setConfig({
                            themeColor: "#1D896D",
                            logoUrl: "",
                            logoWide: "",
                            logoFavicon: ""
                        });
                        return;
                    }
                }
                // }
                if (!!campaignPath && !!customerData && !customerData?.code && !!campaignLocal && !!campaignLocal?.isRequireAccessCode && (location.pathname !== `/${clientCode}/${campaignPath}/` && location.pathname !== `/${clientCode}/${campaignPath}`)) {
                    localStorage.setItem('PREV_URL', location.href);
                    navigate(`/${clientCode}/${campaignPath}/401`);
                }
                // setup theme
                const color = campaignLocal?.business?.themeColor || "";
                setThemeColors({main: color !== "#40a68c" ? color : ""})
                setBusiness(campaignLocal?.business);
                setConfig({
                    ...(campaignLocal?.business || {}),
                    themeColor: color,
                    logoUrl: campaignLocal?.business.logoUrl,
                    logoWide: campaignLocal?.business.logoWide,
                    logoFavicon: campaignLocal?.business.logoFavicon
                })
            }


            await refreshData(['service'], true);


            setLoading(false);
        }
        run().finally(() => {
            setReady(true);
        });
    }, []);

    const getLocalUrlParams = () => {
        const url = new URL(window.location.href);
        // get product service id from url params if exist /:clientCode/:campaignPath/:campaignId/:customerId/product-and-service/:productServiceType/:productServiceId/:quantity/
        const result = url.pathname.match(/\/([^\/]+)\/([^\/]+)\/([^\/]+)\/([^\/]+)\/([^\/]+)\/([^\/]+)\/([^\/]+)\/([^\/]+)/);
        return result ? {
            clientCode: result[1],
            campaignPath: result[2],
            campaignId: result[3],
            customerId: result[4],
            productServiceType: result[6],
            productServiceId: result[7],
            quantity: result[8]
        } : null;
    }

    const refreshData = async (items: Array<"campaign" | "service">, forceUpdate?: boolean) => {
        if (items.includes('service')) {
            try {
                const params = getLocalUrlParams();
                // load product service detail if not exist
                if (params?.campaignId && !!params?.productServiceId && (forceUpdate || !getLocalProductService(params?.productServiceId)?.id)) {
                    const result = await getProductAndService(params?.campaignId, params?.productServiceId);
                    if (result.status === 200) {
                        setLocalProductService(params?.productServiceId, result?.data?.data || {});
                    }
                }
            } catch (e) {
            }
        }
        if (items.includes('campaign')) {
            try {
                const result = await getCampaignByUrl(campaignPath);
                if (result.status === 200) {
                    setCampaignError(false);
                    setCampaign(result?.data?.data);
                } else {
                    setCampaignError(true);
                    navigate(`/${clientCode}/404/${campaignPath}`)
                }
            } catch (e) {
            }
        }
    }

    const loadConfig = async () => {
        const clientCacheConfig = window.localStorage.getItem(`APP_THEME_${clientCode}`);
        if (!!clientCacheConfig) {
            const result = JSON.parse(clientCacheConfig);
            setConfig(result);
            getClientConfig().then(result => {
                if (result.status === 200 && result?.data?.data) {
                    const data = result?.data?.data;
                    setConfig(data)
                }
            })
        } else {
            // upadte new
            const result = await getClientConfig();
            const data = result?.data?.data || {};
            setConfig(data)
        }
    }

    useEffect(() => {
        if (customer) {
            localStorage.setItem('CUSTOMER', JSON.stringify(customer));
        }
        if (campaign) {
            localStorage.setItem(`CAMPAIGN_${campaignPath}`, JSON.stringify(campaign));
        }
    }, [customer, campaign]);


    const setConfig = (data) => {
        data = data || {};
        if (!!Object.keys(data || {}).includes('createdFromOrg')) {
            localStorage.setItem(`APP_THEME_${clientCode}`, JSON.stringify(data));
        } else {
            data.createdFromOrg = true;
        }
        win.document.querySelector("title").innerText = data?.name || T("Booking Anywhere");
        var link: any = win.document.querySelector("link[rel~='icon']");
        if (!link) {
            link = win.document.createElement('link');
            link.rel = 'icon';
            win.document.head.appendChild(link);
        }

        if (data?.createdFromOrg) {
            win.appTheme = {
                ...data,
                color: data?.themeColor || "#1D896D",
                rawLogo: data?.logoUrl,
                logoUrl: data?.logoUrl || assetUrl('/logoNull.svg'),
                isDefault: false
            };
            setThemeColors({main: win.appTheme.color});
            link.href = data?.logoFavicon || data?.logoUrl || data?.logoWide || `https://img.icons8.com/ios-filled/${win.appTheme.color.replace('#', '')}/50/circled-${data?.name?.length ? data?.name[0]?.toLowerCase() : win.location.hostname.split("")[0]}.png`;
        } else {
            win.appTheme = {
                ...data,
                rawLogo: data?.logoUrl,
                color: (win.location.origin.includes('localhost') ? "#008ff8" : "#1D896D"),
                logoUrl: assetUrl('/icons/logoFull.svg'),
                isDefault: true
            };
            setThemeColors({main: win.appTheme.color});
            link.href = data?.logoFavicon || data?.logoUrl || data?.logoWide || assetUrl('/logo.svg');
        }
    }

    // save booking to cache
    const getAllBooking = () => {
        const str = localStorage.getItem(`BOOKING_${customer?.customerId}`);
        return str ? JSON.parse(str) : null;
    }
    const getCurrentBooking = (index) => {
        const bookings = getAllBooking()
        if (bookings) {
            return bookings[index] ? bookings[index] : null;
        }
        return null;
    }
    const setCurrentBooking = (booking, index) => {
        let bookings = getAllBooking();
        if (!bookings) {
            bookings = [];
        }
        bookings[index] = booking;
        localStorage.setItem(`BOOKING_${customer?.customerId}`, JSON.stringify(bookings));
    }
    const removeCurrentBookings = () => {
        localStorage.removeItem(`BOOKING_${customer?.customerId}`);
    }
    // save question to cache
    const getAllAnswers = () => {
        const str = localStorage.getItem(`ANSWERS_${customer?.customerId}`);
        return str ? JSON.parse(str) : [];
    }
    const addAnswered = (answer) => {
        const items = getAllAnswers() || [];
        items.push(answer);
        localStorage.setItem(`ANSWERS_${customer?.customerId}`, JSON.stringify(items));
    }
    const getAnswered = (packageIndex) => {
        const items = getAllAnswers() || [];
        return items.find(item => item?.packageIndex?.toString() === packageIndex?.toString())
    }
    // save service
    const getLocalProductService = (id) => {
        const str = localStorage.getItem(`SERVICE_${id}`);
        return str ? JSON.parse(str) : {};
    }

    const setLocalProductService = (id, value) => {
        localStorage.setItem(`SERVICE_${id}`, JSON.stringify(value));
    }
    // save booking portal code
    const getLocalAddress = (id) => {
        const str = localStorage.getItem(`BOOKING_POSTAL_CODE_${id}`);
        return str ? JSON.parse(str) : {};
    }

    const setLocalAddress = (id, value) => {
        localStorage.setItem(`BOOKING_POSTAL_CODE_${id}`, JSON.stringify(value));
    }
    // save add-on
    const getLocalAddon = (id) => {
        const str = localStorage.getItem(`ADDON_${id}`);
        return str ? JSON.parse(str) : [];
    }

    const setLocalAddon = (id, value) => {
        localStorage.setItem(`ADDON_${id}`, JSON.stringify(value));
    }

    return (
        <App.Provider
            value={{
                setLoading,
                T: T,
                campaign,
                customer,
                setCustomer,
                setCampaign,
                campaignPath,
                campaignError,
                getCurrentBooking, setCurrentBooking, getAllBooking, removeCurrentBookings,
                addAnswered, getAnswered,
                getLocalProductService, setLocalProductService,
                getLocalAddress, setLocalAddress,
                themeColors, setThemeColors, business,
                clientCode,
                getLocalAddon, setLocalAddon,
                refreshData,
            }}>
            {ready ? children : null}
            {loading ? (<Loading/>) : null}
        </App.Provider>
    )
}

export const useApp: any = () => React.useContext(App);
